<script setup>
import {useStore} from "vuex";
import {computed} from "vue";
import BaseModal from "@/components/global-themed/BaseModal.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import AwaitingInstallationContent from "@/components/onsiteOptimizer/installation/modals/partials/AwaitingInstallationContent.vue";

const emit = defineEmits(['close']);
const store = useStore();
const user = computed(() => store.getters['user/user']);

const isSoftwarePlus = computed(() => !!user?.value.active_website.done_with_you);
</script>

<template>
  <BaseModal @close="emit('close')">
    <div class="tw-px-8 tw-flex tw-flex-col tw-gap-8 tw-justify-center tw-text-left tw-pb-8">
      <h2 class="tw-text-2.5xl tw-text-grey-dark tw-font-bold">
        We’re On It!
      </h2>

      <AwaitingInstallationContent
        :is-software-plus="isSoftwarePlus"
      />

      <div class="tw-flex tw-w-full tw-justify-center">
        <div class="tw-w-1/3">
          <DefaultButton
            as="a"
            class="tw-mt-5"
            :href="`${isSoftwarePlus ? 'https://calendly.com/hikeseo/support-new-customer-call' : 'https://calendly.com/hike-seo/meet-your-account-managers' }`"
            target="_blank"
          >
            Book Your 1-to-1 Call
          </DefaultButton>
        </div>
      </div>
    </div>
  </BaseModal>
</template>
